import { render, staticRenderFns } from "./policyHolderDetailInfo.vue?vue&type=template&id=aefdd19c&scoped=true&"
import script from "./policyHolderDetailInfo.vue?vue&type=script&lang=js&"
export * from "./policyHolderDetailInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefdd19c",
  null
  
)

export default component.exports